/*
  1. Dolly /Tractors can be adhoc (i.e provided by contractors) in that case the user
  can select "/DOLLY" for dolly & "/POWER" for tractors.
  2. TRAILER_NUMBER=/BOB for bobtail flow

*/
const constants = {
  ADHOC_DOLLY: "/DOLLY",
  TRAILER_NUMBER_FOR_BOBTAIL: "/BOB",
  DEFAULT_DOLLY: "/TBF",
  DEFAULT_TRACTOR: "/TBF",
  ERROR_MESSAGES: {
    REQUIRED:"* Required",
    DUPLICATE_TRAILER:"Duplicate trailer",
    DUPLICATE_DOLLY:"Duplicate dolly",
    VALID_DRIVER_STATUS: "Driver unavailable for dispatch",
    DRIVER_CLOCKED_IN_STATUS : "Driver not clocked-in",
    DISPATCH_DRIVER_EVENT_FAILED: "Failed to dispatch driver",
    DRIVER_DISPATCHED: "Driver already dispatched",
    STRAIGHT_TRUCK_REQUIRED: "Straight truck is required",
    SAME_STRAIGHT_TRUCK_REQUIRED: "Same straight truck is required",
    DEFAULT_DOLLY: "/TBF dolly is not allowed",
    DEFAULT_TRACTOR: "/TBF tractor is not allowed",
    MAX_ALLOWED_TRAILERS: "You have already dispatched the maximum number of trailers for this driver",
    ALREADY_DISPATCHED_STRAIGHT_TRUCK: "Driver has already dispatched with a straight truck",
    ACTIVE_DRIVER_CANNOT_PRE_DISPATCH_STRAIGHT_TRUCK: "Selected driver has active routes, cannot pre-dispatch with a straight truck",
    STRAIGHT_TRUCK_NOT_ALLOWED_AFTER_NON_ST: "Straight truck cannot be dispatched with other trailers",
  },
  RMAX_EMPTY_TRAILER_CODE: "MTY", //for different clients rmaxCode will be "MTY" but status can be different, check in getClientCode api
  RMAX_CLOSED_TRAILER_CODE: "CLO", // same for all clients: trailer is closed
  ROUTE_NAME_MAX_LENGTH: 50,
  ROUTE_NAME_DEFAULT: 'DEFAULTROUTE', // Backend placeholder; do not add to route options
  TRAILER_PARKING_TYPE: {
    D: 'Door',
    A: 'Yard',
  },
  ODOMETER_CONSTANTS : {
    MIN_READING_DIFFERENCE: 2,
    MAX_READING_DIFFERENCE: 600,
    MAX_READING: [9999998, 9999999],
  },
  SUBMIT_LABELS: {
    DISPATCH: "Dispatch",
    PRE_DISPATCH: "Pre-Dispatch",
  },
}

export default constants;